module.exports = __webpack_public_path__ + "static/media/girl.ab255543.webp";